import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NgIf } from "@angular/common";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ConductorDTO } from '../../../dtos/conductor.dto';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiService } from '../../services/api.service';
import moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { PdfDTO } from '../../../dtos/pdf.dto';
import { AppMessage } from '../../app.message';
import { ToastrService } from 'ngx-toastr';
import { ViajeDTO } from "../../../dtos/viaje.dto";
import { UserService } from "../../services/user.service";
import { ConfiguracionEstadoConductorDTO } from '../../../dtos/configuracionEstadoConductor.dto';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'app-modal-print',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    TooltipModule
  ],
  templateUrl: './modal-print.component.html',
  styleUrl: './modal-print.component.scss'
})

export class ModalPrintComponent {
  // tiposForm: FormGroup;

  conductor: ConductorDTO;
  viaje: ViajeDTO;
  from: string;

  public procesandoPdf: boolean = false;

  //CON-1056: estados que tienen vale, para ofrecer la reimpresion mientras el conductor siga en uno
  public configuraciones: Array<ConfiguracionEstadoConductorDTO> = [];

  constructor(
    private modalRef: BsModalRef,
    private toastr: ToastrService,
    // private formBuilder: FormBuilder,
    private apiService: ApiService,
    private userService: UserService
  ) {

    if (this.from == 'sinoptico')
      this.conductor = this.viaje.conductor;
  }

  ngOnInit(): void {
    this.cargarConfiguracionEstados();
    // this.tiposForm = this.formBuilder.group({
    //   tipoImpresion: new FormControl(null, [Validators.required]),
    // });
    // this.valueChanges();
  }

  // valueChanges() {
  // this.tiposForm.valueChanges.subscribe(valor => {
  //   if (valor.tipoImpresion === 'COLACION' && this.conductor.jornadaEnCurso.colacionFechaInicioReal !== null) {
  //     this.getColacionPDF();
  // if (this.conductor.jornadaEnCurso.colacionFechaInicioReal !== null) {
  //   this.getColacionPDF();
  // } else if (this.conductor.jornadaEnCurso.colacionPermitida && this.conductor.jornadaEnCurso.colacionFechaInicioReal === null) {
  //   this.alertService.presentAlertaInfo('No registra colación en jornada');
  // } else if (!this.conductor.jornadaEnCurso.colacionPermitida) {
  //   this.alertService.presentAlertaInfo('No cumple con los requisitos para imprimir');
  // }
  // } else if (valor.tipoImpresion === 'JORNADA') {
  //   this.getFinJornadaPDF();
  // }
  // });
  // }

  close() {
    this.modalRef.hide();
  }

  //CON-1056 -----------------------------------------------------------------------------------

  cargarConfiguracionEstados() {
    //solo aplica al modal abierto desde conductores; en sinoptico no se imprime vale de estado
    if (this.from != 'conductores') return;

    this.apiService.getConfiguracionEstadosConductor().subscribe({
      next: (resp) => this.configuraciones = resp.data || [],
      //si no llega la configuracion simplemente no se ofrece el vale de estado
      error: (err) => console.log('error configuracion estados conductor', err)
    });
  }

  /** El vale se puede imprimir mientras el conductor este en uno de los estados que lo tienen. */
  get puedeImprimirValeEstado(): boolean {
    if (!this.conductor || !this.conductor.estado) return false;
    return this.configuraciones.some(c => c.codigoEstado === this.conductor.estado);
  }

  /**
   * Vale del estado actual del conductor. Reemplaza al de colacion: el endpoint nuevo cubre los
   * cinco estados -colacion incluida- y se puede llamar las veces que haga falta.
   */
  imprimirValeEstado() {
    this.procesandoPdf = true;
    this.apiService.getEstadoConductorPDF(this.conductor.uuid).subscribe(
      (resp) => this.getColacionPDFSuccess(resp),
      (error) => this.getColacionPDFError(error)
    );
  }

  /**
   * El endpoint del vale de estado pide VOUCHER_ESTADO_CONDUCTOR, que el back hereda de los
   * perfiles que ya tenian VOUCHER_COLACION. Se aceptan los dos para no esconder el boton en los
   * ambientes donde la migracion del permiso nuevo todavia no corrio.
   */
  tienePermisoImprimirValeEstado(): boolean {
    return this.userService.tienePermiso('VOUCHER_ESTADO_CONDUCTOR') || this.userService.tienePermiso('VOUCHER_COLACION');
  }

  tienePermisoImprimirColacion(): boolean {
    return this.userService.tienePermiso('VOUCHER_COLACION');
  }

  tienePermisoImprimirJornada(): boolean {
    return this.userService.tienePermiso('VOUCHER_JORNADA');
  }

  tienePermisoImprimirRutaViaje(): boolean {
    return this.userService.tienePermiso('VOUCHER_RUTA_VIAJE');
  }

  /**
   * CON-1057: cambiar el bus o el conductor anula la confirmacion, y el vale de un viaje sin
   * confirmar no respalda nada. El backend ya lo rechaza con 409; aca se evita el intento.
   */
  get viajeConfirmado(): boolean {
    return !!this.viaje && this.viaje.confirmado;
  }

  get tooltipImprimirRutaViaje(): string | null {
    if (!this.viajeConfirmado) return 'El viaje no está confirmado. Confírmelo antes de imprimir el vale';
    return null;
  }

  get getTiempoEnEstadoHHmm(): string {
    if (!this.conductor?.estadoFechaInicio) return '';

    const fechaAhora = moment.utc();
    const fechaInicio = moment.utc(this.conductor.estadoFechaInicio);
    const duracion = moment.duration(fechaAhora.diff(fechaInicio));

    const horas = Math.floor(duracion.asHours());
    const minutos = duracion.minutes();

    return `${this.pad(horas)}:${this.pad(minutos)}`;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  getFinJornadaPDF() {
    this.procesandoPdf = true;
    this.apiService.getFinJornadaPDF(this.conductor.jornadaEnCurso.uuid).subscribe(
      (resp) => this.getFinJornadaPDFSuccess(resp),
      (error) => this.getFinJornadaPDFError(error)
    );
  }

  getFinJornadaPDFSuccess(pdfDTO: PdfDTO,) {
    pdfDTO.generatePdfFromBase64();
    this.toastr.success('Documento generado correctamente', '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
    this.close();
  }

  getFinJornadaPDFError(error: HttpErrorResponse) {
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getColacionPDF(uuidConductor: string) {
    this.procesandoPdf = true;
    this.apiService.getColacionPDF(uuidConductor).subscribe(
      (resp) => this.getColacionPDFSuccess(resp),
      (error) => this.getColacionPDFError(error)
    );
  }

  getColacionPDFSuccess(pdfDTO: PdfDTO,) {
    this.procesandoPdf = false;
    if (pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });

    // this.alertService.presentAlertaInfo(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`);

    this.toastr.success('Documento generado correctamente', '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
    this.close();
  }

  getColacionPDFError(error: HttpErrorResponse) {
    this.procesandoPdf = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getRutaViajePDF() {
    this.procesandoPdf = true;
    this.apiService.getRutaViajePDF(this.viaje.uuid)
      .subscribe((resp) => this.getRutaViajePDFSuccess(resp), (error) => this.getRutaViajePDFError(error));
  }

  getRutaViajePDFSuccess(pdfDTO: PdfDTO) {
    console.log('exito pdf');
    this.procesandoPdf = false;
    if (pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
  }

  getRutaViajePDFError(error: HttpErrorResponse) {
    this.procesandoPdf = false;
    console.log('error kpis', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }
}
